import React, { useMemo, useState, useEffect } from 'react';
import { getEventObject } from '../../utils/EventUtils';

/**
 * props:
 * - id
 * - quantity
 * - isQuote
 * - text
 * - symbol
 * - allowQuote
 * - onChange
 */
function QuantityInput(props) {

    const [isQuote, setIsQuote] = useState(false);

    useEffect(() => {
        setIsQuote(props.isQuote === 'true' || props.isQuote === true);
    }, [props.isQuote]);

    function onCalcClick(event) {
        props.onChange(getEventObject('isQuote', !isQuote));
    }

    function getPlaceHolder() {
        return isQuote ? props.symbol.minNotional : props.symbol.minLotSize;
    }

    // Maior quantidade VÁLIDA para o saldo disponível: o saldo cru quase nunca é múltiplo do
    // stepSize (9.8608 XRP com step 0.1), e a corretora recusa com LOT_SIZE. Sem isto, "vender
    // tudo" obriga o usuário a fazer a conta de cabeça — foi o caso real de 08/08.
    function maxValidQuantity() {
        const saldo = parseFloat(props.availableQty);
        const step = parseFloat(props.symbol && props.symbol.stepSize);
        if (!(saldo > 0)) return null;
        if (!(step > 0)) return saldo;
        const casas = (String(props.symbol.stepSize).split('.')[1] || '').replace(/0+$/, '').length;
        const ajustada = +(Math.floor((saldo + 1e-12) / step) * step).toFixed(casas);
        return ajustada > 0 ? ajustada : null;
    }

    function onMaxClick() {
        const max = maxValidQuantity();
        if (max !== null) props.onChange(getEventObject(props.id, `${max}`));
    }

    const quantityInput = useMemo(() => {
        const max = isQuote ? null : maxValidQuantity();
        const step = props.symbol && props.symbol.stepSize;
        return (
            <div className='form-group'>
                <label htmlFor={props.id}>{props.text}</label>
                <div className='input-group'>
                    {
                        props.allowQuote
                            ? <button type='button' className='btn btn-secondary d-inline-flux align-items-center' onClick={onCalcClick}>
                                {isQuote ? props.symbol.quote : props.symbol.base}
                            </button>
                            : <React.Fragment></React.Fragment>
                    }
                    <input type='number' id={props.id} value={props.quantity} className='form-control' placeholder={getPlaceHolder()} onChange={props.onChange} />
                    {
                        max !== null
                            ? <button type='button' className='btn btn-outline-secondary' onClick={onMaxClick} title={`Usar o máximo válido: ${max}`}>Máx</button>
                            : <React.Fragment></React.Fragment>
                    }
                </div>
                {
                    // Dica PERMANENTE, não só depois do erro: a regra da corretora fica visível antes
                    // de custar uma ordem rejeitada.
                    !isQuote && parseFloat(step) > 0
                        ? <small className='text-muted'>Múltiplos de {step.replace(/0+$/, '').replace(/\.$/, '')}{max !== null ? ` · máximo válido: ${max}` : ''}</small>
                        : <React.Fragment></React.Fragment>
                }
            </div>
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.quantity, props.isQuote, props.allowQuote, props.symbol, props.availableQty, isQuote]);

    return quantityInput;
}

export default QuantityInput;